import React from 'react';
import { CheckIcon, BookOpenIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { pillars, method, audience, PRODUCT, METHOD_FLOW } from '../data/content';
export function MethodSection() {
  return <section aria-labelledby="metodo" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-156" data-mp="2uqtupc6b5hm">
      <Reveal data-id="element-157" data-mp="3v042t42abckj">
        <p className="text-xs font-bold uppercase tracking-[0.24em] text-gold" data-id="element-158" data-mp="viwdf8rhqofv">
          No necesitás estudiar teología para empezar
        </p>
        <h2 id="metodo" className="mt-2 flex items-center justify-center gap-2 font-display text-2xl md:text-3xl font-bold uppercase leading-tight text-ink" data-id="element-159" data-mp="ql4cxqcs5u02">
          <BookOpenIcon size={22} className="text-accent" data-id="element-160" data-mp="hqg8u3ixyicu" />
          {PRODUCT}
        </h2>
        <p className="mx-auto mt-3 max-w-3xl text-base text-ink-muted" data-id="element-161" data-mp="1e9njo1g6lyq1">
          Muchas veces no te faltan ganas. Te falta{' '}
          <span className="font-semibold text-ink" data-id="element-162" data-mp="19h49zfkm7nqi">una guía</span>: un mapa,
          contexto, un orden y un método sencillo que puedas incorporar a tu
          día.
        </p>
      </Reveal>

      <ol className="mt-8 grid gap-3 md:grid-cols-3" data-id="element-163" data-mp="200shqhf0aefs">
        {pillars.map((pillar, i) => <Reveal key={pillar.title} as="li" delay={i * 0.04} className="flex h-full flex-col items-center rounded-2xl border border-line bg-surface p-6 text-center" data-id="element-164" data-mp="1lbnzj087oa7o" data-mpi={i}>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-soft font-display text-base font-bold text-accent" data-id="element-165" data-mp="1cdu6pz9nnyp9">
              {i + 1}
            </span>
            <h3 className="mt-3 font-display text-lg font-bold uppercase tracking-wide text-ink" data-id="element-166" data-mp="12fed9pn5odcl">
              {pillar.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-167" data-mp="2wruh6jshbfea">
              {pillar.desc}
            </p>
          </Reveal>)}
      </ol>

      <Reveal delay={0.06} className="mt-6 rounded-2xl border border-accent/20 bg-accent-soft p-6 md:p-8" data-id="element-168" data-mp="31pw9lvbsor2f">
        <h3 className="font-display text-xl font-bold uppercase tracking-wide text-accent" data-id="element-169" data-mp="2vafc5h7ojbpx">
          El método 15 Minutos con la Palabra™
        </h3>
        <p className="mt-2 text-sm text-ink-muted" data-id="element-170" data-mp="2qc43h9t4f79a">
          Una rutina sencilla para transformar tu manera de estudiar las
          Escrituras.
        </p>
        <ol className="mx-auto mt-5 grid max-w-4xl gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-171" data-mp="3izqc4wh7h230">
          {method.map(step => <li key={step.title} className="flex flex-col items-center rounded-xl bg-surface px-4 py-4 text-center" data-id="element-172" data-mp="3e1ydzkpywjqd">
              <span className="rounded-full bg-gold-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-gold" data-id="element-173" data-mp="358l9rmmgdvoz">
                {step.time}
              </span>
              <span className="mt-2 font-display text-lg font-bold uppercase tracking-wide text-ink" data-id="element-174" data-mp="5mengtgolff0">
                {step.title}
              </span>
              <span className="mt-1 text-sm text-ink-muted" data-id="element-175" data-mp="1jhohstqvl5ql">{step.desc}</span>
            </li>)}
        </ol>
        <p className="mt-5 text-sm font-bold uppercase tracking-[0.16em] text-accent" data-id="element-176" data-mp="1oh9gr461pe3b">
          {METHOD_FLOW}
        </p>
      </Reveal>

      <Reveal delay={0.08} className="mt-6" data-id="element-177" data-mp="1sjxp7aqukizr">
        <h3 className="text-sm font-bold uppercase tracking-[0.2em] text-gold" data-id="element-178" data-mp="1xh66l9468izy">
          Este Mega Pack es para vos si…
        </h3>
        <ul className="mx-auto mt-4 grid max-w-4xl gap-2 sm:grid-cols-2" data-id="element-179" data-mp="22fhf9giqcngl">
          {audience.map(item => <li key={item} className="flex items-center justify-center gap-2 rounded-xl border border-line bg-surface px-4 py-3 text-sm text-ink" data-id="element-180" data-mp="27czhko28s4fm">
              <CheckIcon size={14} className="flex-shrink-0 text-accent" strokeWidth={3} data-id="element-181" data-mp="2g6m9g33bwnjj" />
              <span data-id="element-182" data-mp="2q522iblx26vo">{item}</span>
            </li>)}
        </ul>
        <p className="mt-4 text-sm font-semibold text-ink-muted" data-id="element-183" data-mp="2ciuww8zufjo4">
          No necesitás conocimientos teológicos previos.
        </p>
      </Reveal>
    </section>;
}